import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { readEndpoint } from 'redux-json-api';
import { LayerGroup } from 'react-leaflet';

import Railway from './Railway';
import { selectRailways } from '../modules/selectors/railway';

class Railways extends Component {
  static propTypes = {
    readEndpoint: PropTypes.func.isRequired,
    railways: PropTypes.array.isRequired
  };

  render () {
    const { railways } = this.props;

    if (railways.length === 0) return null;

    return (
      <LayerGroup>
        {railways.map(railway => (
          <Railway
            key={railway.id}
            id={railway.id}
            railway={railway}
          />
        ))}
      </LayerGroup>
    );
  }
};

const mapStateToProps = (state) => ({
  railways: selectRailways(state),
});

const mapDispatchToProps = {
  readEndpoint
};

export default connect(mapStateToProps, mapDispatchToProps)(Railways);
